export default __webpack_public_path__ + "static/media/icon_chevron_hub_left_mobile.ccc7a834.svg";